export default "/_next/static/images/27/article3-27faaa43ac1ec8cbbbcd5629ba18207b.jpg";